import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-apple"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M12.8625 3.98848H12.9125C14.2933 3.98848 15.4125 2.86919 15.4125 1.48848V1.43848H15.3625C13.9818 1.43848 12.8625 2.55776 12.8625 3.93848V3.98848Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M20.2872 8.10012C19.3499 6.79124 17.8267 6.11368 16.2411 6.01052C15.1337 5.92923 14.1306 6.29423 13.3245 6.59686C12.9088 6.75295 12.4537 6.96932 12.0005 6.96932C11.5266 6.96932 11.0566 6.7545 10.6217 6.58975C9.85047 6.29758 9.06529 6.02991 8.2308 6.05934C6.40219 6.12385 4.73409 7.1297 3.78666 8.70334C1.45223 12.5721 3.63566 18.3873 6.73366 21.1592C7.30727 21.6724 7.94536 22.0193 8.67202 21.9981C9.93863 21.9442 11.009 21.1306 12.2994 21.1306C13.5877 21.1306 14.668 21.992 15.9491 21.9636C18.5355 21.9218 20.1454 18.3533 20.8483 16.3414C19.1061 15.6333 17.9171 14.018 17.8951 12.1058C17.8751 10.4378 18.8823 8.93365 20.2872 8.10012Z","fillRule":"evenodd","clipRule":"evenodd"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M20.2872 8.10014C19.3499 6.79126 17.8267 6.1137 16.2411 6.01055C15.1337 5.92926 14.1306 6.29426 13.3245 6.59688C12.9088 6.75298 12.4537 6.96935 12.0005 6.96935C11.5266 6.96935 11.0566 6.75453 10.6217 6.58978C9.85047 6.2976 9.06529 6.02993 8.2308 6.05937C6.40219 6.12388 4.73409 7.12973 3.78666 8.70336C1.45223 12.5721 3.63566 18.3873 6.73366 21.1592C7.30727 21.6724 7.94536 22.0193 8.67202 21.9981C9.93863 21.9443 11.009 21.1307 12.2994 21.1307C13.5877 21.1307 14.668 21.992 15.9491 21.9636C18.5355 21.9218 20.1454 18.3533 20.8483 16.3414C19.1061 15.6333 17.9171 14.018 17.8951 12.1058C17.8751 10.4378 18.8823 8.93368 20.2872 8.10014Z","fillRule":"evenodd","strokeWidth":"props.strokeWidth","clipRule":"evenodd"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M12.8625 3.98848H12.9125C14.2933 3.98848 15.4125 2.86919 15.4125 1.48848V1.43848H15.3625C13.9818 1.43848 12.8625 2.55776 12.8625 3.93848V3.98848Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const LogoApple = Vue.extend<IconProps>({
  name: 'LogoAppleIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-apple',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoApple;
